import { useState ,useEffect} from "react";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Typography,
    TextField

} from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import React from "react";
import { useSelector } from "react-redux";
import { Loadable } from "../loadable";

const useStyles = makeStyles((theme) => ({
    button: {
        padding: "0.25rem",
    },
}));

export function DeleteConfirmation({
    reducerName= undefined,
    customCancelBtnText=undefined,
    preserverOriginalHTMLFormat=false,
    pageReducerName= undefined,
    doubleConfirm=false,
    stateName= undefined,
    children = undefined,
    handleDelete,
    isPending=false,
    isConfirmationOnly=false,
    handleClose,
    customTitle=undefined,
    tooltip=undefined,
    hideDeleteBtn=false,
    defaultSelected=undefined,
    canDelete=true,
    defaultDeleteState=undefined,
    buttonColor = undefined,
    customIcon=undefined,
    iconSize = undefined,
    isDeleting = false,
    customConfirmBtnText=undefined,
    DELETE_TEXT = "Are you sure you want to delete these Items ?",
    NO_ITEMS_TEXT = "No Items Selected for deleting",
}) {

    const { open, rowData }: any =defaultDeleteState || useSelector((state) =>
        state[reducerName]
            ? state[reducerName][stateName]
            : { open: false, rowData: null }
    );
    const { selected }: any = defaultSelected ? {selected:defaultSelected}:useSelector((state: any) =>
        state?.pagesV2 ? state?.pagesV2[pageReducerName] : { selected: [] }
    );

    useEffect(() => {
        if (!open) {
            setInputValue("");
        }
    }, [open]);

      const [inputValue, setInputValue] = useState('');

    const handleConfirmDelete = () => {
        handleDelete(rowData ? [rowData?.id] : selected);
    };
    const handleChange = (e) => {
        setInputValue(e.target.value);
    };
    
    const canProceed = inputValue.trim().toLowerCase() === 'yes';

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{ "& .MuiPaper-root": { minWidth: "350px" } }}
        >
            <Loadable loading={isDeleting || isPending}>
                <DialogTitle>{customTitle || "Delete"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        {selected?.length === 0 &&
                        !rowData &&
                        !isConfirmationOnly
                            ? NO_ITEMS_TEXT
                            :preserverOriginalHTMLFormat ?<div dangerouslySetInnerHTML={{__html:DELETE_TEXT}}/>:DELETE_TEXT }
                        {children}

                        {(selected?.length > 0 || rowData) && doubleConfirm && (
                            <>
                                <Typography color="primary" sx={{ my: "10px" }}>
                                    Please type <span style={{color:"red"}}><b>"Yes"</b></span> to proceed:
                                </Typography>
                                <TextField
                                    placeholder="Yes"
                                    variant="filled"
                                    value={inputValue}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                />
                            </>
                        )}
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>{customCancelBtnText || "Cancel"}</Button>
                    {(selected?.length > 0 || rowData || isConfirmationOnly) &&
                        !hideDeleteBtn && (
                            <Button
                                disabled={!canDelete || (doubleConfirm && !canProceed)}
                                variant="contained"
                                onClick={handleConfirmDelete}
                                color="primary"
                            >
                                {customConfirmBtnText || "Delete"}
                            </Button>
                        )}
                </DialogActions>
            </Loadable>
        </Dialog>
    );
}
